import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Box } from '@mui/material';
import HospitalDTO from '@src/adapters/dto/hospital/HospitalDTO';
import useCachedHospitalList from '@src/adapters/hooks/hospital/useCachedHospitalList';
import useFindHospitalsAllLazy from '@src/adapters/hooks/hospital/useFindHospitalsAll';

interface Props {
  selection(hospitals: HospitalDTO[]): void;
  selectedIds: string[];
  all?: boolean;
}

function HospitalsAutoComplete({ selection, selectedIds, all }: Props) {
  const [open, setOpen] = useState(false);
  const [available, setAvailable] = useState<HospitalDTO[]>([]);
  const [selected, setSelected] = useState<HospitalDTO[]>([]);
  const { getList } = useCachedHospitalList();
  const { execute: getAllHospitals } = useFindHospitalsAllLazy();
  const loading = open;

  useEffect(() => {
    if (all) {
      getAllHospitals().then((result) => {
        setAvailable(result.hospitals);
      });
    } else {
      getList().then((result) => {
        setAvailable(result);
      });
    }
  }, [getList, getAllHospitals, all]);

  useEffect(() => {
    if (selectedIds && selectedIds.length > 0) {
      setSelected(available.filter((o) => selectedIds.includes(o.id)));
    } else {
      setSelected([]);
    }
  }, [available, selectedIds]);

  const onOpen = () => {
    setOpen(true);
  };

  const updateSelected = (values: HospitalDTO[]) => {
    selection(values);
  };

  return (
    <Box>
      <Autocomplete
        multiple
        open={open}
        disableClearable={true}
        value={selected}
        onOpen={onOpen}
        onClose={() => {
          setOpen(false);
        }}
        onChange={(option, values) => {
          updateSelected(values);
        }}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(option) =>
          option.organisation
            ? `${option.name} (${option.organisation.name})`
            : option.name
        }
        options={[...available]}
        loading={loading}
        filterSelectedOptions={true}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Hospitals"
            variant="standard"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </Box>
  );
}
export default HospitalsAutoComplete;
